export default __webpack_public_path__ + "static/media/ic_olympus_arbitrum.2d52c3f7.svg";